import React, { useState } from 'react';
import {
  TOTAL_SCREENS,
  GET_SCREEN_INDEX,
} from '../../../utilities/commonUtils';
import ScrollService from '../../../utilities/ScrollService';
import './Header.css';

// Hoisted to module scope — doesn't close over any component state, so rebuilding
// it on every render is wasted work
const updateCurrentScreen = (currentScreen) => {
  if (!currentScreen || !currentScreen.screenInView) return;
  let screenIndex = GET_SCREEN_INDEX(currentScreen.screenInView);
  if (screenIndex < 0) return;
};

export default function Header() {
  const [selectedScreen, setSelectedScreen] = useState(0);
  const [showHeaderOptions, setShowHeaderOptions] = useState(false);

  // let currentScreenSubscription = //turn on later
  ScrollService.currentScreenBroadCaster.subscribe(updateCurrentScreen);

  const getHeaderOptions = () => {
    return TOTAL_SCREENS.map((Screen, i) => (
      <div
        key={Screen.screen_name}
        className={getHeaderOptionsClass(i)}
        // role+tabIndex+onKeyDown make this div keyboard-accessible (a11y)
        role="button"
        tabIndex={0}
        onClick={(e) => {
          // stopPropagation prevents the click from bubbling to a parent toggle handler
          e.stopPropagation();
          switchScreen(i, Screen);
        }}
        onKeyDown={(e) => e.key === 'Enter' && switchScreen(i, Screen)}
      >
        <span>{Screen.screen_name}</span>
      </div>
    ));
  };

  const getHeaderOptionsClass = (index) => {
    let classes = 'header-option ';
    if (index < TOTAL_SCREENS.length - 1) classes += 'header-option-seperator ';
    if (selectedScreen === index) classes += 'selected-header-option';
    return classes;
  };

  const switchScreen = (index, screen) => {
    let screenComponent = document.getElementById(screen.screen_name);
    if (!screenComponent) return;
    screenComponent.scrollIntoView({ behavior: 'smooth' });
    setSelectedScreen(index);
    setShowHeaderOptions(false);
  };

  return (
    // No onClick on the container — the button inside is the sole toggle trigger.
    // Having onClick on both a parent and child with functional updates causes double-toggle.
    <div className="header-container">
      <div className="header-parent">
        <div className="header-hamburger">
          <div>
            {/* type="button" prevents accidental form submission; aria-label gives screen readers a name.
                onClick lives only here — not duplicated on any ancestor div. */}
            <button
              type="button"
              aria-label="Toggle navigation menu"
              className="relative group"
              onClick={() => setShowHeaderOptions((prev) => !prev)}
            >
              {/* className instead of class — React ignores the HTML attribute name in JSX */}
              <div className="relative flex overflow-hidden items-center justify-center rounded-full w-[50px] h-[50px] transform transition-all bg-transparent ring-0 ring-gray-300 hover:ring-8 group-focus:ring-4 ring-opacity-30 duration-200 shadow-md">
                <div className="flex flex-col justify-between w-[20px] h-[20px] transform transition-all duration-300 origin-center overflow-hidden">
                  <div className="bg-white h-[2px] w-7 transform transition-all duration-300 origin-left group-focus:translate-x-10"></div>
                  <div className="bg-white h-[2px] w-7 rounded transform transition-all duration-300 group-focus:translate-x-10 delay-75"></div>
                  <div className="bg-white h-[2px] w-7 transform transition-all duration-300 origin-left group-focus:translate-x-10 delay-150"></div>

                  <div className="absolute items-center justify-between transform transition-all duration-500 top-2.5 -translate-x-10 group-focus:translate-x-0 flex w-0 group-focus:w-12">
                    <div className="absolute bg-white h-[2px] w-5 transform transition-all duration-500 rotate-0 delay-300 group-focus:rotate-45"></div>
                    <div className="absolute bg-white h-[2px] w-5 transform transition-all duration-500 -rotate-0 delay-300 group-focus:-rotate-45"></div>
                  </div>
                </div>
              </div>
            </button>
          </div>
        </div>

        <div className="header-logo">
          <span>CHRIS BOLOSAN</span>
        </div>
        <div
          className={
            showHeaderOptions
              ? 'header-options show-hamburger-options'
              : 'header-options'
          }
        >
          {getHeaderOptions()}
        </div>
      </div>
    </div>
  );
}
